import { render, staticRenderFns } from "./PositionSettings.vue?vue&type=template&id=1ed0efa8&"
import script from "./PositionSettings.vue?vue&type=script&lang=js&"
export * from "./PositionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports